import React from "react";
import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { composeQA } from "@multiweb/reactUtils";
import { IMenuItemData } from "@multiweb/types/contracts";
// @ts-ignore // 27385: [PP] 3. 2. 2020: Bez tohoto se do d.ts generovaly importy tohoto enumu s absolutním aliasem, kde být nemohou.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IAppState, QAProps } from "@multiweb/types/react";
import { createMenuItemActivatedAction } from "../../actions";
import { isActionItemFocused, isItemFocused, MenuFocusableItemType, NavigationSection } from "../../navigation";
import { getFormInstanceLabel, isOpenedItemActive, OpenedFormItemInfo } from "../../openedItems";
import {
    areFormItemWindowActionsEnabled,
    getFormItem,
    getFormItemIconCode,
    isFormItemInstanceCloseActionEnabled,
} from "../../selectors";
import { MenuItemActivatedType } from "../../types";
import { createMenuItemKeyActivationHandler, createOpenableInTabItemMouseActivationHandler } from "../../utils";
import { MenuItemComponent, MenuItemComponentProps } from "../MenuItemComponent";
import { OpenedFormItemRightPartComponent } from "../OpenedFormItemRightPartComponent";

export type OpenedFormItemProps = {
    /** Informace o otevřené položce formuláře. */
    openedFormItemInfo: OpenedFormItemInfo;
    /** Sekce, ve které je položka vykreslená. Slouží pro určování zaměření. */
    section: NavigationSection;
} & QAProps;

type DispatchProps = {
    openedFormItemActivated: typeof createMenuItemActivatedAction;
};

type StateProps = {
    windowActionsEnabled: boolean;
    formItem?: IMenuItemData;
    isActionItemFocused: boolean;
    isCloseActionEnabled: boolean;
} & Pick<MenuItemComponentProps, "label" | "iconCode" | "isFocused" | "isActive">;

const mapStateToProps: MapStateToProps<StateProps, OpenedFormItemProps, IAppState> = (state, { openedFormItemInfo, section }) => {
    const { formInstanceId, menuItemId: formItemId } = openedFormItemInfo;
    return {
        formItem: getFormItem(state, formItemId),
        iconCode: getFormItemIconCode(state, formItemId),
        label: getFormInstanceLabel(state, formInstanceId),
        windowActionsEnabled: areFormItemWindowActionsEnabled(state, formItemId),
        isFocused: isItemFocused(state, { itemId: formInstanceId, type: MenuFocusableItemType.openedItem, section }),
        isActionItemFocused: isActionItemFocused(state, { parentItemId: formInstanceId, section }),
        isActive: isOpenedItemActive(state, openedFormItemInfo.formInstanceId),
        isCloseActionEnabled: isFormItemInstanceCloseActionEnabled(state, formInstanceId),
    };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OpenedFormItemProps> = {
    openedFormItemActivated: createMenuItemActivatedAction,
};

const mergeProps: MergeProps<StateProps, DispatchProps, OpenedFormItemProps, MenuItemComponentProps> = (
    { label, iconCode, windowActionsEnabled, isFocused, isActionItemFocused, isActive, isCloseActionEnabled },
    { openedFormItemActivated },
    { openedFormItemInfo, qa, section },
) => {
    const { formInstanceId } = openedFormItemInfo;
    return {
        label,
        iconCode,
        onClick: createOpenableInTabItemMouseActivationHandler(formInstanceId, MenuItemActivatedType.openedForm, section, openedFormItemActivated),
        onKeyUp: createMenuItemKeyActivationHandler(formInstanceId, MenuItemActivatedType.openedForm, section, openedFormItemActivated),
        rightPartComponentCreator: (isActive) => (
            <OpenedFormItemRightPartComponent
                formInstanceId={openedFormItemInfo.formInstanceId}
                {...{ isActive, windowActionsEnabled, isCloseActionEnabled, isActionItemFocused, section }}
            />
        ),
        isFocused,
        isActive,
        qa: composeQA(composeQA(openedFormItemInfo.formInstanceId, openedFormItemInfo.formCode), qa),
    };
};

/**
 * Získává data pro zobrazení otevřené menu položky formuláře.
 */
export const OpenedFormItem = connect(mapStateToProps, mapDispatchToProps, mergeProps)(MenuItemComponent);
